import React from 'react';
import PageHero from '../common/PageHero';
import { useTranslation } from 'react-i18next';

const AboutHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageHero
      eyebrow={t('aboutPageSection.hero.eyebrow')}
      title={t('aboutPageSection.hero.title')}
      description={t('aboutPageSection.hero.description')}
      typedTitle
    />
  );
};

export default AboutHero;
